import styled from 'styled-components'
import { Link } from '../Link/Link'

export const BlockLink = styled(Link)`
  display: block;
  color: inherit;
  text-decoration: none;
`

BlockLink.displayName = 'BlockLink'
